import { Button } from 'primereact/button';
import './App.css';
import { useNavigate } from 'react-router-dom';
import V2HomeCard from './V2HomeCard';
import UserHeader from './UserHeader';
import V2Card from './V2Card';
import V2Warning from './devices/V2Warning';

function V2MyAccount({ menu }) {
    const navigage = useNavigate();

    function logout() {
        localStorage.removeItem('token');
        localStorage.removeItem('user_id');
    }

    return (
        <div>
            {menu}
            <V2Card>
                <UserHeader user_id='me' />
            </V2Card>
            <V2HomeCard>
                <V2Card>
                    <div
                        style={{ width: '20em' }}
                        align='left'
                    >
                        <div className='mk2-subtitle'>
                            Security:
                        </div>
                        <div style={{ marginTop: '1em' }}>
                            <Button
                                label='Logout'
                                severity='danger'
                                size='small'
                                outlined
                                onClick={
                                    () => navigage('/')
                                }
                            />
                        </div>
                    </div>
                </V2Card>
                <V2Card>
                    <div className='mk2-subtitle'>
                        Upgrade
                    </div>
                    <V2Warning
                        title='Upgrades are currently disabled for this account. Please contact the administrator.'
                    />
                    <Button
                        severity='secondary'
                        label='Upgrate account'
                        size='small'
                        outlined
                        disabled={true}
                        style={{ marginTop: '1em' }}
                    />
                </V2Card>
            </V2HomeCard>
        </div>
    );
}

export default V2MyAccount;